<template>
  <div>
    <div class="skill">
      <div class="form-group skill__header">
        <c-switcher v-model="form.language.show" label="Иностранный язык" />
      </div>

      <transition name="slide">
        <div v-if="form.language.show" class="skill__config">
          <div class="form-group skill_required">
            <c-switcher v-model="form.language.required" type="checkbox" label="Обязательное" />
          </div>

          <div class="skill__params">
            <div class="skill-param">
              <div class="skill-param__name">Параметр Иностранный язык</div>
              <list-params
                :form="form.language.param"
                field-name="Иностранный язык"
                :field-type="fieldType"
                @change="$emit('editDictionary', 'languages')"
              />
            </div>
            <div class="skill-param">
              <div class="skill-param__name">Параметр Уровень</div>
              <list-params
                :form="form.language.level"
                field-name="Уровень владения"
                :field-type="fieldType"
                @change="$emit('editDictionary', 'languageLevels')"
              />
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div class="skill">
      <div class="form-group skill__header">
        <c-switcher v-model="form.program.show" label="Программа" />
      </div>

      <transition name="slide">
        <div v-if="form.program.show" class="skill__config">
          <div class="form-group skill_required">
            <c-switcher v-model="form.program.required" type="checkbox" label="Обязательное" />
          </div>

          <div class="skill__params">
            <div class="skill-param">
              <div class="skill-param__name">Параметр Программа</div>
              <list-params
                :form="form.program.param"
                field-name="Программа"
                :field-type="fieldType"
                @change="$emit('editDictionary', 'programs')"
              />
            </div>
            <div class="skill-param">
              <div class="skill-param__name">Параметр Уровень</div>
              <list-params
                :form="form.program.level"
                field-name="Уровень владения"
                :field-type="fieldType"
                @change="$emit('editDictionary', 'programLevels')"
              />
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import CSwitcher from "@/components/controls/switcher";
import ListParams from "@/pages/profile/form/components/ListParams";

export default {
  components: { CSwitcher, ListParams },
  props: ["form", "field", "fieldType"],
};
</script>

<style lang="scss" scoped>
.skill {
  &__params {
    display: flex;
    margin-left: -15px;
    margin-right: -15px;
  }
  &__config {
    padding-left: 20px;
    padding-bottom: 25px;
  }
  &-param {
    flex-basis: 50%;
    margin-left: 15px;
    margin-right: 15px;

    &__name {
      font-weight: 500;
      font-size: 13px;
      margin-bottom: 15px;
    }
  }
}
</style>
